import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger.js'
import { throttle } from 'lodash-es'
import { mapGetters } from 'vuex'
import { langRoute } from '@/config/language'

export default {
  data() {
    return {
      curPath: '',
      scrollTriggerSelf: null
    }
  },
  created() {
    const anchorName = this.$route.hash && this.$route.hash.replace('#', '')
    anchorName && this.activeAnchorName(anchorName)
    this.curPath = this.$router.name
  },
  computed: {
    ...mapGetters({
      isTransparent: 'isTransparent',
      isWhite: 'isWhite'
    })
  },
  watch: {
    '$route.name': {
      handler(val, oldVal) {
        if (val === oldVal) return
        this.isHome = langRoute.some((lang) => val === `index___${lang}`)
      },
      immediate: true
    }
  },
  mounted() {
    if (process.browser) {
      gsap.registerPlugin(ScrollTrigger)
      // 滚动混入
      this.getBnnerHeight()
      this.createAnim()
    }
  },
  methods: {
    // 锚点效果
    activeAnchorName(anchorName) {
      this.$nextTick(() => {
        const anchorElement = document.getElementById(anchorName)
        if (anchorElement) {
          anchorElement.scrollIntoView({ behavior: 'smooth' })
        }
      })
    },
    // 滚动
    getBnnerHeight() {
      this.$nextTick(() => {
        // 获取banner 高度
        const bannerEl = document.getElementsByClassName('banner')[0]
        if (bannerEl) {
          this.bannerHeigth = bannerEl['offsetHeight'] + 50
        }

        this.navAnchor = document.getElementsByClassName('nav-anchor')[0]
      })
    },
    handleHideNavStatus(windowScrollY, height = 50) {
      const hideNavStatus = this.bannerHeigth && windowScrollY >= this.bannerHeigth - height
      return hideNavStatus
    },
    createAnim() {
      const that = this
      // 导航隐藏显示动画
      this.showAnim = gsap
        .from('.full-head', {
          yPercent: -100,
          // backgroundColor: '#fff',
          paused: true,
          // markers: true, // 绘制线条
          duration: 0.2
          // ease: 'linear'
        })
        .progress(1)
      that.scrollTriggerSelf = ScrollTrigger.create({
        start: 'top top',
        end: 99999,
        // markers: true, // 绘制线条
        // scrub: true,
        // pin: true,
        onUpdate: throttle(function (self) {
          const windowScrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop
          if (that.bannerHeigth && windowScrollY >= that.bannerHeigth - 150) {
            that.$store.commit('scrollNavBg', false)
          } else {
            !that.isWhite && that.$store.commit('scrollNavBg', true)
          }
          if (that.bannerHeigth && windowScrollY >= that.bannerHeigth) {
            if (self.direction === -1) {
              that.showAnim.play()
              if (that.navAnchor) {
                that.navAnchor.style.top = '0.75rem'
              }
            } else {
              if (that.navAnchor) {
                that.navAnchor.style.top = '0px'
              }
              that.showAnim.reverse()
            }
          }
        }, 100)
      })
    }
  },
  destroyed() {
    // gsap.to('.full-head', {
    //   yPercent: 0,
    //   duration: 0.2
    // })
    this.showAnim.play()
    this.scrollTriggerSelf.disable(false, true)
    // this.scrollTriggerSelf.kill()
    // this.showAnim.reverse()
    console.log('[ destroyed ] >', 'destroyed')
  }
}
